module.exports = __webpack_public_path__ + "static/media/dryer-alt.19d64336.svg";